export const config = {
  loginApiUrl: import.meta.env.VITE_LOGIN_API_URL ?? "",
  redirectUrl: import.meta.env.VITE_REDIRECT_URL ?? "",
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID ?? "",
  allowedRedirectDomains: Array.from(
    new Set(
      (import.meta.env.VITE_ALLOWED_REDIRECT_DOMAINS ?? "")
        .split(",")
        .map((domain) => domain.trim().toLowerCase())
        .filter(Boolean)
    )
  ).map((domain) => {
    try {
      // Normalize to punycode to avoid homograph bypasses
      return new URL(`https://${domain}`).hostname.toLowerCase();
    } catch {
      return domain;
    }
  }),
};
